import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DirectionsBoatFilledIcon from "@mui/icons-material/DirectionsBoatFilled";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import EngineeringIcon from "@mui/icons-material/Engineering";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import "../styles/Pricing.css";

function FeatureList({ items }) {
  return (
    <ul className="pricingFeatureList">
      {items.map((item) => (
        <li key={item}>
          <CheckCircleOutlineIcon />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

function Pricing() {
  const { t } = useTranslation();
  const surveyItems = t("pricing.survey.items", { returnObjects: true });
  const maintenanceItems = t("pricing.maintenance.items", { returnObjects: true });

  return (
    <main className="pricingPage">
      <section className="pricingHero">
        <div>
          <h1>{t("pricing.title")}</h1>
          <p>{t("pricing.description")}</p>
        </div>
        <Link className="pricingHeroButton" to="/iletisim">
          {t("pricing.contactButton")}
        </Link>
      </section>

      <p className="pricingNotice pricingNoticeGlobal">{t("pricing.validityNotice")}</p>

      <section className="pricingGrid" aria-label={t("pricing.ariaLabel")}>
        <article className="pricingCard pricingCardFeatured">
          <div className="pricingCardHeader">
            <DirectionsBoatFilledIcon />
            <div>
              <h2>{t("pricing.survey.title")}</h2>
              <p>{t("pricing.survey.subtitle")}</p>
            </div>
          </div>

          <div className="pricingAmount">
            <span>{t("pricing.survey.unit")}</span>
            <strong className="campaignPrice">
              <del>{t("pricing.survey.oldPrice")}</del>
              <span>{t("pricing.survey.newPrice")}</span>
            </strong>
          </div>

          <FeatureList items={surveyItems} />
        </article>

        <article className="pricingCard">
          <div className="pricingCardHeader">
            <BuildCircleIcon />
            <div>
              <h2>{t("pricing.maintenance.title")}</h2>
              <p>{t("pricing.maintenance.subtitle")}</p>
            </div>
          </div>

          <div className="maintenanceList">
            {maintenanceItems.map((item) => (
              <div className="maintenanceItem" key={item.title}>
                <div>
                  <h3>{item.title}</h3>
                  {item.note && <p>{item.note}</p>}
                  {item.details && <FeatureList items={item.details} />}
                </div>
                <strong>{item.price}</strong>
              </div>
            ))}
          </div>
        </article>

        <article className="pricingCard consultingCard">
          <div className="pricingCardHeader">
            <EngineeringIcon />
            <div>
              <h2>{t("pricing.consulting.title")}</h2>
              <p>{t("pricing.consulting.subtitle")}</p>
            </div>
          </div>

          <div className="pricingAmount compact">
            <span>{t("pricing.consulting.label")}</span>
            <strong>{t("pricing.consulting.price")}</strong>
          </div>
        </article>
      </section>
    </main>
  );
}

export default Pricing;
